import axios from 'axios'
import { endPoints } from '../../config/endpoints'
import { CALL_API } from 'tr-components/redux/CallApiMiddlewareActionCreator'

const SET_CLIENT_ID = 'user/SET_CLIENT_ID'
const FETCH_PERMISSIONS_REQUEST = 'user/FETCH_PERMISSIONS_REQUEST'
const FETCH_PERMISSIONS_SUCCESS = 'user/FETCH_PERMISSIONS_SUCCESS'
const FETCH_PERMISSIONS_FAIL = 'user/FETCH_PERMISSIONS_FAIL'

export {
  SET_CLIENT_ID,
  FETCH_PERMISSIONS_REQUEST,
  FETCH_PERMISSIONS_SUCCESS,
  FETCH_PERMISSIONS_FAIL
}

export const initialState = {
  clientId: null,
  permissions: new Set(),
  fetchingPermissions: false,
  fetchedPermissions: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CLIENT_ID:
      return {
        ...state,
        clientId: action.clientId
      }
    case FETCH_PERMISSIONS_REQUEST:
      return {
        ...state,
        fetchingPermissions: true
      }
    case FETCH_PERMISSIONS_SUCCESS:
      const { permissions } = action.payload
      return {
        ...state,
        fetchingPermissions: false,
        permissions: new Set(
          permissions.find((entry) => entry.clientId === state.clientId).permissions
        ),
        fetchedPermissions: true
      }
    case FETCH_PERMISSIONS_FAIL:
      return {
        ...state,
        fetchingPermissions: false,
        fetchedPermissions: true
      }
    default:
      return state
  }
}

export default reducer

export function setClientId(clientId) {
  return {
    type: SET_CLIENT_ID,
    clientId: clientId
  }
}

export const getPermissions = () => ({
  type: CALL_API,
  types: [FETCH_PERMISSIONS_REQUEST, FETCH_PERMISSIONS_SUCCESS, FETCH_PERMISSIONS_FAIL],
  callAPI: () =>
    axios.get('/users', {
      baseURL: endPoints.base
    })
})



// WEBPACK FOOTER //
// ./src/redux/reducers/user.js